import { render, staticRenderFns } from "./ServiceLandingSection.vue?vue&type=template&id=4d6ccdc6&scoped=true"
import script from "./ServiceLandingSection.vue?vue&type=script&lang=js"
export * from "./ServiceLandingSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceLandingSection.vue?vue&type=style&index=0&id=4d6ccdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ccdc6",
  null
  
)

export default component.exports